



















































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Emit, Watch, Ref } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import ReservaDeSangueStore from '@/components/SolicitacaoCirurgia/store/ReservaDeSangueStore'
import SolicitacaoCirurgiaStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoCirurgiaStore'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import { onlyNumber, onlyFloat, timeout, validateLength, validateCPF, validateDate, timeoutDefault } from '@/utils/common'
import { ReservaDeSangueIndicacaoEnum } from '@/types/_'
import EventBus from '@/plugins/EventBus'

@Component

export default class ComponentModalReservaDeSangue extends Vue {
  $refs!: {
    formReservaDeSangue: any,
    reacaoTransfusional: any,
    concentradoHemaciasIndicacoes: any,
    concentradoPlaquetasIndicacoes: any,
    plasmaFrescoCongeladoIndicacoes: any,
    crioprecipitadoIndicacoes: any,
    concentradoHemaciasQuantidade: any,
    concentradoPlaquetasQuantidade: any,
    plasmaFrescoCongeladoQuantidade: any,
    crioprecipitadoQuantidade: any,
    concentradoHemaciasFiltrado: any,
    concentradoPlaquetasFiltrado: any,
  }

  reservaDeSangue: any = {
    valid: true,
    nomePacienteRules: [
      v => !!v || 'Campo obrigatório.',
      v => validateLength(v, 8) || 'O campo deve ter pelo menos 8 caracteres.',
    ],
    nomeMae: [
      // eslint-disable-next-line
      v => (!!v ? validateLength(v, 8) : true) || 'O campo deve ter pelo menos 8 caracteres.',
    ],
    dataNascimentoRules: [
      v => !!v || 'Campo obrigatório.',
      v => validateDate(v) || 'Data inválida.',
    ],
    cpfRules: [
      v => !!v || 'Campo obrigatório.',
      v => validateCPF(v) || 'Cpf inválido.',
    ],
    sexoRules: [
      v => !!v || 'Campo obrigatório.',
    ],
    reacaoTransfusionalRules: [
      v => (v === true || v === false) || 'Campo obrigatório.',
    ],
    reacaoTransfusionalEspecificarRules: [
      v => (this.$refs.reacaoTransfusional.value === true && !!v) || 'Especifique a reação.',
    ],
    gestacaoPreviaRules: [
      v => v !== null || 'Campo obrigatório.',
    ],
    abortoPrevioRules: [
      v => v !== null || 'Campo obrigatório.',
    ],
    pacienteTransplantadoRules: [
      v => v !== null || 'Campo obrigatório.',
    ],
    pesoRules: [
      v => (parseFloat(v) > 0) || 'Campo obrigatório.',
    ],
    htRules: [
      v => (parseFloat(v) > 0) || 'Campo obrigatório.',
    ],
    hbRules: [
      v => (parseFloat(v) > 0) || 'Campo obrigatório.',
    ],
    plaquetasRules: [
      v => (parseInt(v, 10) > 0) || 'Campo obrigatório.',
    ],
    dataExameRules: [
      v => !!v || 'Campo obrigatório.',
    ],
    concentradoHemaciasIndicacoesRules: [
      v => v !== '' || 'Campo obrigatório.',
    ],
    concentradoHemaciasIndicacoesEspecificarRules: [
      v => (this.$refs.concentradoHemaciasIndicacoes.value !== null && this.$refs.concentradoHemaciasIndicacoes.value === ReservaDeSangueIndicacaoEnum.OutroEspecifique && !!v) || 'Especifique a indicação.',
    ],
    concentradoHemaciasQuantidadeRules: [
      v => this.validateQuantidade('concentradoHemaciasIndicacoes', v) || 'Informe a quantidade.',
    ],
    concentradoPlaquetasIndicacoesRules: [
      v => v !== '' || 'Campo obrigatório.',
    ],
    concentradoPlaquetasIndicacoesEspecificarRules: [
      v => (this.$refs.concentradoPlaquetasIndicacoes.value !== null && this.$refs.concentradoPlaquetasIndicacoes.value === ReservaDeSangueIndicacaoEnum.OutroEspecifique && !!v) || 'Especifique a indicação.',
    ],
    concentradoPlaquetasQuantidadeRules: [
      v => this.validateQuantidade('concentradoPlaquetasIndicacoes', v) || 'Informe a quantidade.',
    ],
    plasmaFrescoCongeladoIndicacoesRules: [
      v => v !== '' || 'Campo obrigatório.',
    ],
    plasmaFrescoCongeladoIndicacoesEspecificarRules: [
      v => (this.$refs.plasmaFrescoCongeladoIndicacoes.value !== null && this.$refs.plasmaFrescoCongeladoIndicacoes.value === ReservaDeSangueIndicacaoEnum.OutroEspecifique && !!v) || 'Especifique a indicação.',
    ],
    plasmaFrescoCongeladoQuantidadeRules: [
      v => this.validateQuantidade('plasmaFrescoCongeladoIndicacoes', v) || 'Informe a quantidade.',
    ],
    crioprecipitadoIndicacoesRules: [
      v => v !== '' || 'Campo obrigatório.',
    ],
    crioprecipitadoIndicacoesEspecificarRules: [
      v => (this.$refs.crioprecipitadoIndicacoes.value !== null && this.$refs.crioprecipitadoIndicacoes.value === ReservaDeSangueIndicacaoEnum.OutroEspecifique && !!v) || 'Especifique a indicação.',
    ],
    crioprecipitadoQuantidadeRules: [
      v => this.validateQuantidade('crioprecipitadoIndicacoes', v) || 'Informe a quantidade.',
    ],
  }

  validateQuantidade(field: string, value: any): boolean {
    if (this.$refs[field].value === null) return true
    if (this.$refs[field].value !== null && this.$refs[field].value === ReservaDeSangueIndicacaoEnum.NaoAplica) return true
    return parseInt(value, 10) > 0
  }

  mdReservaDeSangue: boolean = true
  loadClose: boolean = false
  loadEnviar: boolean = false

  get getReservaDeSangueStore() {
    return getModule(ReservaDeSangueStore, this.$store)
  }

  get getSolicitacaoCirurgiaStore() {
    return getModule(SolicitacaoCirurgiaStore, this.$store)
  }

  get reservaDeSangueDisabled() {
    return this.getReservaDeSangueStore.reservaDeSangueDisabled
  }

  get showModalReservaDeSangue() {
    return this.getReservaDeSangueStore.modalReservaDeSangue.reservaDeSangue
  }

  set showModalReservaDeSangue(value: boolean) {
    this.getReservaDeSangueStore.setShowModalReservaDeSangue(value)
  }

  get loadingClose() {
    return this.loadClose
  }

  set loadingClose(value: boolean) {
    this.loadClose = value
  }

  get loadingEnviar() {
    return this.loadEnviar
  }

  set loadingEnviar(value: boolean) {
    this.loadEnviar = value
  }

  onlyFloatUtil(num) {
    return onlyFloat(num)
  }

  onlyNumberUtil(num) {
    return onlyNumber(num)
  }

  reacaoTransfusionalChanges() {
    this.getReservaDeSangueStore.clearReacaoTransfusionalEspecificar()
  }

  concentradoDePlaquetasChanges() {
    this.getReservaDeSangueStore.clearConcentradoDePlaquetasEspecificar()
  }

  plasmaFrescoCongeladoChanges() {
    this.getReservaDeSangueStore.clearPlasmaFrescoCongeladoEspecificar()
  }

  crioprecipitadoChanges() {
    this.getReservaDeSangueStore.clearCrioprecipitadoEspecificar()
  }

  concentradoDeHemaciasChanges() {
    this.getReservaDeSangueStore.clearConcentradoDeHemaciasEspecificar()
  }

  // Limpar reserva de sangue via ref
  clearReservaDeSangue() {
    this.getReservaDeSangueStore.clearReservaDeSangue()
  }

  async closeModalReservaDeSangue() {
    this.loadingClose = true
    this.getReservaDeSangueStore.setShowModalReservaDeSangue(false)
    this.getReservaDeSangueStore.setReservaDeSangueDisabled(false)
    this.loadingClose = false
  }

  clearQuantidade(field: string) {
    const { reservaDeSangue } = this.getReservaDeSangueStore
    if (reservaDeSangue.solicitacaoReservaDeSangue[field].indicacoes === ReservaDeSangueIndicacaoEnum.NaoAplica) {
      this.getReservaDeSangueStore.clearQuantidade({ campo: field })
    }

    return reservaDeSangue.solicitacaoReservaDeSangue[field].indicacoes === ReservaDeSangueIndicacaoEnum.NaoAplica
  }

  // Somente para o formulário de pré-anestesia do backoffice...
  get isBackofficeRoute() {
    return String(this.$route.path).includes('backoffice')
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  async enviarReservaDeSangue() {
    this.loadingEnviar = true

    if (this.$refs.formReservaDeSangue.validate()) {
      const response = await this.getReservaDeSangueStore.putReservaDeSangue(
        this.isBackofficeRoute
          ? this.getBackofficeGlobalStore.solicitacao.id
          : this.getSolicitacaoCirurgiaStore.solicitacaoCirurgia.id,
      )
      if (response.success) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Reserva realizado com sucesso!', icon: 'done', color: '#2E7D32' })
        await this.closeModalReservaDeSangue()
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu um erro ao enviar a reserva.', icon: 'warning', color: '#C62828' })
      }
    } else {
      // eslint-disable-next-line
      const errors = await this.$refs.formReservaDeSangue._data.errorBag
      const counter = Object.values(errors).filter(e => e === true).length
      EventBus.$emit('setSnackbar', { show: true, text: `Foram encontrados ${counter} erro(s) no formulário`, icon: 'warning', color: '#C62828' })
    }

    this.loadingEnviar = false
  }
}
